import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import ForumEntityClassSchema, {
  ForumEntityClassParams,
} from "notifications/values/forum-entity-class/forum-entity-class-schema";

export default class ForumEntityClass {
  public static fromJSON(value: unknown): ForumEntityClass | null | undefined {
    if (isNullOrUndefined(value)) return value;
    const params = ForumEntityClassSchema.deserialize(value);
    return new ForumEntityClass(params);
  }

  public constructor(public readonly value: ForumEntityClassParams) {
    ForumEntityClassSchema.validate(value);
  }

  public toJSON(): string {
    return this.value;
  }

  public clone(): ForumEntityClass {
    return new ForumEntityClass(this.value);
  }

  public isEqualTo(other?: ForumEntityClass): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return this.value;
  }
}
